import ArrayMobile from './array-mobile.svg';
import Array from './array.svg';
import AutoFit from './auto-fit.svg';
import BackgroundRemovalMobile from './background-removal-mobile.svg';
import BackgroundRemoval from './background-removal.svg';
import BevelMobile from './bevel-mobile.svg';
import Bevel from './bevel.svg';
import Brightness from './brightness.svg';
import ConvertToImage from './convert-to-image.svg';
import ConvertToPathMobile from './convert-to-path-mobile.svg';
import ConvertToPath from './convert-to-path.svg';
import CreateTextpath from './create-textpath.svg';
import Crop from './crop.svg';
import DecomposeMobile from './decompose-mobile.svg';
import DecomposeTextpath from './decompose-textpath.svg';
import Decompose from './decompose.svg';
import Delete from './delete.svg';
import DisassembleMobile from './disassemble-mobile.svg';
import Disassemble from './disassemble.svg';
import EditImage from './edit-image.svg';
import EditPathMobile from './edit-path-mobile.svg';
import EditPath from './edit-path.svg';
import Grading from './grading.svg';
import Invert from './invert.svg';
import Offset from './offset.svg';
import Outline from './outline.svg';
import ReplaceMobile from './replace-mobile.svg';
import Replace from './replace.svg';
import RotaryWarped from './rotary-warped.svg';
import SharpenMobile from './sharpen-mobile.svg';
import Sharpen from './sharpen.svg';
import SimplifyMobile from './simplify-mobile.svg';
import Simplify from './simplify.svg';
import SmartNest from './smart-nest.svg';
import Stamp from './stamp.svg';
import Tab from './tab.svg';
import Trace from './trace.svg';
import Upscale from './upscale.svg';
import WeldText from './weld-text.svg';

export default {
  Array,
  ArrayMobile,
  AutoFit,
  BackgroundRemoval,
  BackgroundRemovalMobile,
  Bevel,
  BevelMobile,
  Brightness,
  ConvertToImage,
  ConvertToPath,
  ConvertToPathMobile,
  CreateTextpath,
  Crop,
  Decompose,
  DecomposeMobile,
  DecomposeTextpath,
  Delete,
  Disassemble,
  DisassembleMobile,
  EditImage,
  EditPath,
  EditPathMobile,
  Grading,
  Invert,
  Offset,
  Outline,
  Replace,
  ReplaceMobile,
  RotaryWarped,
  Sharpen,
  SharpenMobile,
  Simplify,
  SimplifyMobile,
  SmartNest,
  Stamp,
  Tab,
  Trace,
  Upscale,
  WeldText,
};
